/**
 * RoleDashboardLayout - Wrapper for role-specific dashboards
 * 
 * Provides:
 * - AppLayout with role-based nav filtering
 * - AgentNotification (single WebSocket, app-level toasts)
 * 
 * Each role dashboard imports this instead of AppLayout directly.
 */

import React from 'react';
import AppLayout, { NavRole } from './AppLayout';
import AgentNotification from './pipeline/AgentNotification';

interface RoleDashboardLayoutProps {
  children: React.ReactNode;
  role?: NavRole;
}

export default function RoleDashboardLayout({ children, role }: RoleDashboardLayoutProps) {
  return (
    <AppLayout navRole={role}>
      {children}
      <AgentNotification position="bottom-right" maxNotifications={4} autoDismissMs={8000} />
    </AppLayout>
  );
}
